import React from 'react';
import Debounce from 'react-debounce-component';
import { pluralize } from 'swag-common/utils/strings';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import classnames from 'classnames';
import animationClasses from './error-appear.anim.scss';
import classes from './multiple-products-selection-error.scss';
export let ERROR_TYPES = /*#__PURE__*/function (ERROR_TYPES) {
  ERROR_TYPES["ZERO_QUANTITY_SELECTED"] = "ZERO_QUANTITY_SELECTED";
  ERROR_TYPES["MORE_THAN_CAP"] = "MORE_THAN_CAP";
  ERROR_TYPES["MORE_THAN_AVAILABLE_FOR_VARIANT"] = "MORE_THAN_AVAILABLE_FOR_VARIANT";
  return ERROR_TYPES;
}({});
const ERROR_TYPE_TO_MESSAGE = {
  [ERROR_TYPES.MORE_THAN_CAP]: ({
    cap,
    totalAmountForColorVariant
  }) => {
    return `You can select up to ${cap} ${pluralize(cap, 'item', 's', true)}, total ${totalAmountForColorVariant} selected`;
  },
  [ERROR_TYPES.MORE_THAN_AVAILABLE_FOR_VARIANT]: ({
    available
  }) => {
    return `Only ${available} ${pluralize(available, 'product', 's', true)} are available in stock.`;
  },
  [ERROR_TYPES.ZERO_QUANTITY_SELECTED]: () => {
    return 'Total quantity of selected product need to bigger than 0.';
  }
};
function ErrorMessage({
  text,
  animationKey,
  className
}) {
  return /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    key: animationKey,
    classNames: animationClasses,
    unmountOnExit: true,
    timeout: 200
  }, /*#__PURE__*/React.createElement(Debounce, {
    ms: 200
  }, /*#__PURE__*/React.createElement("div", {
    "data-message": "error-message",
    className: classnames(classes.error, className)
  }, text))));
}
export const MultipleProductsSelectionError = ({
  error,
  className
}) => {
  if (!error) {
    return /*#__PURE__*/React.createElement(ErrorMessage, {
      animationKey: null,
      text: null
    });
  }
  const funcToCall = ERROR_TYPE_TO_MESSAGE[error.type];
  const text = funcToCall === null || funcToCall === void 0 ? void 0 : funcToCall(error.data);
  return /*#__PURE__*/React.createElement(ErrorMessage, {
    className: className,
    animationKey: error.type,
    text: text
  });
};